const NonBillableReason = {
    // Change ID
    "flexPay": {
        _id: process.env.REACT_APP_FLEX_PAY_NON_BILLABLE_ID,
        title: 'Flex Pay',
    },
};

export default NonBillableReason;